import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { IReorderBriefConfigTaskRequest } from "@shared/lib/types/briefConfig";
import { ToastService } from "@shared/lib/services";

export function useReorderBriefConfigTask(briefId: string) {
  const {
    mutate: reorderTask,
    isLoading: isReordering,
    isSuccess: isReordered,
  } = useMutation({
    mutationFn: ({ data }: { data: IReorderBriefConfigTaskRequest }) =>
      BriefConfigService.reorderBriefConfigTask(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_CONFIG_QUERY_KEY(briefId) });
    },
  });

  return {
    reorderTask,
    isReordering,
    isReordered,
  };
}
